export default __webpack_public_path__ + "locales/lv/Payments.json?hash=f00a0b57a3ddbe95a6cc16d35fcde740";